(function() {
	'use strict';

	/**
	 * @ngdoc service
	 *
	 *
	 * @description
	 *
	 */
	angular.module('paxMessageConfig').service('PaxMessageConfigService',
			PaxMessageConfigService);

	function PaxMessageConfigService(PaxMessageConfigFactory,
			RemoteService, CommonMasterData) {

		var self = this;
		var model = {
				searchCriteria: PaxMessageConfigFactory.getSearchRequest(),
			paxMsgList :[],
			paxMsgCountrySave:[]
		};

		self.setSearchCriteria = function(searchParams) {
			var paxMsgSearch = PaxMessageConfigFactory.getSearchRequest();
			if(angular.isUndefined(searchParams.countryCode)|| searchParams.countryCode=== null){
				paxMsgSearch.contryCode = null;
			}else{
				paxMsgSearch.contryCode = searchParams.countryCode.icaoCode == null ? searchParams.countryCode.code
						: searchParams.countryCode.icaoCode;
			}
			model.searchCriteria = paxMsgSearch;
		};


		self.getPaxMessagesConfig = function(successFn, errorFn){
			RemoteService.getPaxMessageConfigs(model.searchCriteria).then(
	                function (response) {
	                    if(response.success){
	                        successFn(response.paxMessageCountries);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		};

		self.getPaxMessageTypes = function(successFn, errorFn) {
			RemoteService.getPaxMessageTypes().then(
	                function (response) {
	                    if(response.success){
	                        successFn(response.msgTypes);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );

		};

    self.getPaxMessageApisVersions = function(successFn, errorFn) {
      RemoteService.getPaxMessageApisVersions().then(
        function (response) {
            successFn(response);
        },
        function (error) {
          errorFn(error.msg[0]);
        }
      );

    };

		self.getPaxMessageFields = function(successFn, errorFn) {
			RemoteService.getPaxMessageFields().then(
	                function (response) {
	                    if(response.success){
	                        successFn(response.msgFields);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );

		};

		self.getPaxMessageTriggers = function(successFn, errorFn) {
			RemoteService.getPaxMessageTriggers().then(
			        function (response) {
	                    if(response.success){
	                        successFn(response.triggers);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		};

		self.setEditorData = function (selectedRowData){
			return PaxMessageConfigFactory.editorData(selectedRowData);
		}

		self.setSaveData = function(saveData){
			var save = PaxMessageConfigFactory.getSaveRequest();
			save.countryCode = angular.isUndefined(saveData.countryName.icaoCode)?saveData.countryCode:saveData.countryName.icaoCode;
			save.countryName = saveData.countryName.description;
			save.startDate = saveData.startDate;
			save.endDate = saveData.endDate;
			save.paxMsgCountryId = saveData.paxMsgCountryId;
			save.triggers = saveData.triggers;
			save.paxMsgFields = saveData.paxMsgFields;
			save.paxMsgTypeId = saveData.paxMsgTypeId;
			save.status = saveData.inactive ===false?'ACT':'INA';
			save.version = saveData.version;
			save.zulu = saveData.zulu;
			save.paxMsgApisVersion = saveData.paxMsgApisVersion;
			save.paxMsgCountryEmail = saveData.paxMsgCountryEmail;
			save.recipientIdentification = saveData.recipientIdentification;
      save.messageReleaseNumber = saveData.messageReleaseNumber;
			save.apisOperationTypes = saveData.apisOperationTypes;
			model.paxMsgCountrySave = save;
		}

		self.savePaxMessagesConfig = function(successFn, errorFn){
			RemoteService.savePaxMessageConfig(model.paxMsgCountrySave).then(
			        function (response) {
	                    if(response.success){
	                        successFn(response);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		}

	}
})();
